import React from 'react';
import { autobind } from 'core-decorators';
import { Row, Col } from 'src/componentes/grid';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import List from '../../../componentes/list/tree';
import ListColumn from '../../../componentes/list/list-column';
import LucideIcon from 'src/componentes/lucide-icon';
import Search from 'src/paginas/gestao-risco/processo/search-drawer/SearchDrawer';
import SearchSchema from './search-schema';
import SearchSchemaModal from './search-schema-modal';
import {
  capitalizeFirstLetter,
  lowerCaseAllLetter,
} from '../../../utils/string';
import Dropdown from '../../item/dropdown';
import { getConfiguration } from 'src/services/commonRequests';
import ScoreAcumulado from 'src/componentes/score-acumulado/index';
import { formatNumber } from 'src/utils/number';
import AssistenteVirtual from 'src/components/IA/ChatGPT/AssistenteVirtual';
import ContentManager from 'src/componentes/content-manager';
import Button from 'src/componentes/button';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/errorHandler';
import { Checkbox } from 'src/componentes/Form';
import Tooltip from 'src/componentes/tooltip';
import EmbedPowerBI from 'src/paginas/power-bi/componentes/power-bi-dialog';
import RiscoEditView from 'src/paginas/gestao-risco/risco/RiscoEditView';
import ProcessoEditView from 'src/paginas/gestao-risco/processo/edit';
import { TIPO_INTERACAO_SOPHIE } from 'src/utils/constants';
import Badge from 'src/componentes/Badge';

@autobind
class Processo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saved: 0,
      consolidarSubItens: true,
    };
  }

  componentDidMount() {
    getConfiguration('ItemConfiguracaoRisco')((configuracao) =>
      this.setState({ ...this.state, configuracao })
    )();
    getConfiguration('ItemConfiguracaoProcesso')((configuracaoProcesso) =>
      this.setState({ ...this.state, configuracaoProcesso })
    )();
  }

  renderResponsavel(item) {
    return (
      <div>
        <p style={{ margin: '0 0 3px' }}>{item.area}</p>
        <p>{item.responsavel}</p>
      </div>
    );
  }

  renderNome(item, callback, refreshView) {
    if (!item.nome) {
      return;
    }

    return (
      <a
        tabIndex="-1"
        onClick={this.handleNomeClick.bind(this, item, callback, refreshView)}
        style={{ cursor: 'pointer' }}
      >
        {item.nome}
      </a>
    );
  }

  handleEditClick = (item, parameters, refreshView) => {
    ContentManager.addContent(
      <ProcessoEditView
        item={item}
        currenttabIndex={1}
        parameters={parameters}
        showDelete={true}
        handleClose={refreshView}
      />
    );
  };

  handleNomeClick(item, parameters, refreshView) {
    this.handleEditClick(item, parameters, refreshView);
  }

  renderStatus(item) {
    return (
      <Badge
        pill
        className="text-white"
        style={{ background: item.status.cor }}
      >
        {item.status.descricao}
      </Badge>
    );
  }

  renderLabelMenu() {
    return <LucideIcon icon="EllipsisVertical" />;
  }

  handleClickSophie(item) {
    const { user, intl, resources } = this.props;

    try {
      http
        .post('/Processo/ObterPromptIdentificarRiscos', {
          idProcesso: item?.id,
        })
        .then((response) => {
          const promptCausas = response.data?.promptIdentificarRiscos;
          const msgConsultoraVirtualActioDesvio = intl.formatMessage(
            {
              id: 'labelRiscos',
            },
            { riscos: capitalizeFirstLetter(resources.riscos) }
          );

          ContentManager.addContent(
            <AssistenteVirtual
              user={user}
              prompt={promptCausas}
              title={msgConsultoraVirtualActioDesvio}
              showCause={false}
              actionsToolBar={this.renderButtonCreateRisk()}
              interactionType={
                TIPO_INTERACAO_SOPHIE.SUGERIR_RISCOS_ITENS_IMPACTADOS
              }
            />
          );
        });
    } catch (err) {
      errorHandler(err);
    }
  }

  showCreateRisk() {
    ContentManager.addContent(<RiscoEditView mode="edit" {...this.props} />);
  }

  renderButtonCreateRisk() {
    return [
      <Button
        id={'botaoIdentificarRisco'}
        key={1}
        className="ml-2"
        onClick={() => this.showCreateRisk()}
        type="primary"
      >
        <LucideIcon icon="Plus" />
        <span className="ml-2">
          {capitalizeFirstLetter(this.props.resources.riscos)}
        </span>
      </Button>,
    ];
  }

  renderMenu(item) {
    const { intl, resources } = this.props;

    return (
      <Dropdown
        item={item}
        exibirPowerBI={true}
        showModal={true}
        handleClose={this.refreshView}
        exibirInteligenciaArtificial={true}
        handleRelatorioBIClick={() => this.handleRelatorioBIClick(item)}
        exibirPlanoAcao={true}
        editComponent={ProcessoEditView}
        visaoItensImpactados={true}
        labelAI={intl.formatMessage(
          {
            id: 'labelIdentificarRiscos',
          },
          { riscos: resources.riscos }
        )}
        tooltipAI={intl.formatMessage(
          {
            id: 'msgToolTipIdentificarRiscosItensImpactados',
          },
          { riscos: resources.riscos }
        )}
        handleClickSophieCallBack={this.handleClickSophie}
        renderLabel={this.renderLabelMenu}
      ></Dropdown>
    );
  }

  renderScoreAcumulado(
    { scoreAcumuladoDoGrau },
    exibirPontuacaoColunaScoreRisco
  ) {
    const { user } = this.props;

    return (
      <ScoreAcumulado
        scoreAcumuladoDoGrau={scoreAcumuladoDoGrau}
        showValue={exibirPontuacaoColunaScoreRisco}
        decimalSeparator={user?.decimalSeparator}
        thousandsSeparator={user?.thousandsSeparator}
      />
    );
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.refreshColumns !== this.props.refreshColumns ||
      (newProps.showColumns && !this.state.showColumns)
    ) {
      this.setState({ showColumns: newProps.showColumns });
    }
  }

  renderMaiorGrauRisco({ maiorGrauRisco }) {
    return (
      <div className="d-flex justify-content-center">
        <div
          className="pl-2 pr-2 rounded-lg"
          style={{
            backgroundColor: maiorGrauRisco?.cor,
            color: 'white',
            whiteSpace: 'nowrap',
          }}
        >
          {maiorGrauRisco?.descricao}
        </div>
      </div>
    );
  }

  getListColumn(
    { resources, intl, showColumns },
    configuracao,
    configuracaoProcesso,
    refreshView
  ) {
    const list = [];
    list.push(
      <ListColumn
        tree={true}
        headerText={intl.formatMessage({ id: 'nome' })}
        required
        valueField="nome"
        sortField="UltimaVersao.Nome"
        valueFunction={(item) => this.renderNome(item, null, refreshView)}
        default
      />
    );
    list.push(
      <ListColumn
        headerText={intl.formatMessage({ id: 'codigo' })}
        tooltip="Código de Importação"
        valueField="idIntegracao"
        sortField="UltimaVersao.idIntegracao"
        width={100}
        default
      />
    );
    list.push(
      <ListColumn
        headerText={capitalizeFirstLetter(resources.responsaveis)}
        valueField="responsaveis"
        default
      />
    );
    list.push(
      <ListColumn
        headerText={
          configuracaoProcesso?.exibirPontuacaoColunaScoreRisco
            ? intl.formatMessage(
                { id: 'scoreAcumulado' },
                { risco: resources.risco.toLowerCase() }
              )
            : intl.formatMessage(
                { id: 'grauRisco' },
                { risco: resources.risco.toLowerCase() }
              )
        }
        valueField="scoreAcumuladoDoGrau"
        valueFunction={(item) =>
          this.renderScoreAcumulado(
            item,
            configuracaoProcesso?.exibirPontuacaoColunaScoreRisco
          )
        }
        default
      />
    );
    list.push(
      <ListColumn
        headerText={intl.formatMessage({ id: 'exposicao' })}
        valueField="maiorGrauRisco"
        valueFunction={this.renderMaiorGrauRisco}
        visible={configuracaoProcesso?.calcularNivelExposicaoProcesso}
      />
    );
    list.push(
      <ListColumn
        headerText={capitalizeFirstLetter(resources.area)}
        valueField="area"
        default
      />
    );
    list.push(
      <ListColumn
        headerText={intl.formatMessage({
          id: 'impactoFinanceiroResidualEstimado',
        })}
        sortField="impactoFinanceiroResidualEstimado"
        valueFunction={(item) =>
          item.impactoFinanceiroResidualEstimado ? (
            <div>
              {configuracao?.unidadeMedidaImpactoFinanceiro?.sigla}{' '}
              {formatNumber(item.impactoFinanceiroResidualEstimado, 2)}
            </div>
          ) : (
            <>-</>
          )
        }
        valueField="impactoFinanceiroResidualEstimado"
        visible={configuracao?.acompanharImpactoFinanceiroEventoRisco}
      />
    );
    list.push(
      <ListColumn
        headerText={intl.formatMessage({
          id: 'impactoFinanceiroInerenteEstimado',
        })}
        sortField="impactoFinanceiroInerenteEstimado"
        valueFunction={(item) =>
          item.impactoFinanceiroInerenteEstimado ? (
            <div>
              {configuracao?.unidadeMedidaImpactoFinanceiro?.sigla}{' '}
              {formatNumber(item.impactoFinanceiroInerenteEstimado, 2)}
            </div>
          ) : (
            <>-</>
          )
        }
        valueField="impactoFinanceiroInerenteEstimado"
        visible={
          configuracao?.avaliarRiscoInerente &&
          configuracao?.acompanharImpactoFinanceiroEventoRisco
        }
      />
    );
    list.push(
      <ListColumn
        headerText={`
                  ${intl.formatMessage({
                    id: 'reducaoImpactoFinanceiroRealizado',
                  })} ${
          configuracao?.unidadeMedidaImpactoFinanceiro?.sigla
            ? `(${configuracao?.unidadeMedidaImpactoFinanceiro?.sigla})`
            : ''
        }`}
        sortField="reducaoImpactoFinanceiroRealizado"
        valueFunction={(item) =>
          item.reducaoImpactoFinanceiroRealizado ? (
            <div>
              {configuracao?.unidadeMedidaImpactoFinanceiro?.sigla}{' '}
              {formatNumber(item.reducaoImpactoFinanceiroRealizado, 2)}
            </div>
          ) : (
            <>-</>
          )
        }
        valueField="reducaoImpactoFinanceiroRealizado"
        visible={
          configuracao?.avaliarRiscoInerente &&
          configuracao?.acompanharImpactoFinanceiroEventoRisco
        }
      />
    );
    list.push(
      <ListColumn
        headerText={intl.formatMessage({
          id: 'reducaoImpactoFinanceiroPercentual',
        })}
        sortField="reducaoImpactoFinanceiroPercentual"
        valueFunction={(item) =>
          item.reducaoImpactoFinanceiroPercentual ? (
            <div>
              {formatNumber(item.reducaoImpactoFinanceiroPercentual, 2)} %
            </div>
          ) : (
            <>-</>
          )
        }
        valueField="reducaoImpactoFinanceiroPercentual"
        visible={
          configuracao?.avaliarRiscoInerente &&
          configuracao?.acompanharImpactoFinanceiroEventoRisco
        }
      />
    );

    if (showColumns && showColumns.length > 0) {
      const columnMap = new Map(
        list.map((column) => [column.props.valueField, column])
      );

      const finalColumns = showColumns.map((valueField) => {
        const existingColumn = columnMap.get(valueField);

        if (existingColumn) {
          return {
            ...existingColumn,
            props: { ...existingColumn.props, default: true },
          };
        } else {
          return {
            props: {
              valueField,
              headerText: valueField,
              tree: false,
              visible: true,
              default: true,
            },
            isPlaceholder: true,
          };
        }
      });

      return finalColumns;
    }
    return list;
  }

  setConsolidaAreasSubordinadas(value) {
    this.setState((prevState) => ({
      consolidarSubItens: value,
      saved: prevState.saved + 1,
    }));
  }

  toggleConsolidarSubItens(intl, resources, handleChange) {
    if (this.props.showModal) return;

    return (
      <Row>
        <Col className="pt-3">
          <div className="d-flex align-items">
            <span className="mr-3">
              {intl?.formatMessage(
                { id: 'labelConsolidarRiscosSubItensSuperiores' },
                { riscos: lowerCaseAllLetter(resources.riscos) }
              )}
            </span>
            <Tooltip
              text={intl.formatMessage(
                { id: 'labelTooltipConsolidarRiscosSubItensSuperiores' },
                {
                  riscos: lowerCaseAllLetter(resources.riscos),
                  risco: lowerCaseAllLetter(resources.risco),
                }
              )}
              maxWidth="25vw"
            >
              <div style={{ width: '10px' }}>
                <Checkbox
                  id="switch-consolidaAreasSubordinadas"
                  type="switch"
                  name="consolidaAreasSubordinadas"
                  checked={this.state.consolidarSubItens}
                  onChange={(e) => handleChange(e.target?.checked)}
                />
              </div>
            </Tooltip>
          </div>
        </Col>
      </Row>
    );
  }

  handleRelatorioBIClick(item) {
    http
      .post(`/PowerBI/ObterConfiguracoesPorTipoItem`, {
        itemId: item.id,
        tipoItemId: item.tipo?.id,
      })
      .then((response) => {
        if (item.desdobramento) {
          response.data.model.campo = null;
        }
        ContentManager.addContent(
          <EmbedPowerBI
            itemId={item.id}
            relatorioPBI={response.data.model.relatorioPBI}
            embedURL={response.data.model.embedURL}
            workspacePBI={response.data.model.workspacePBI}
            filtros={response.data.model.filtros}
            embedToken={response.data.model.embedToken}
            usarAutenticacaoMicrosoft={
              response.data.model.usarAutenticacaoMicrosoft
            }
          />
        );
        this.setState({
          isLoading: false,
          resources: {},
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });

    this.props.callback && this.props.callback();
    this.props.closePopover && this.props.closePopover();
  }

  refreshView = (saved) => {
    if (saved) {
      this.setState((prevState) => ({ saved: prevState.saved + 1 }));
    }
  };

  handleNewClick = (itemOrigem, tipoInclusao) => {
    ContentManager.addContent(
      <ProcessoEditView
        url="/gerenciar/ponto-controle"
        tipoInclusaoParams={tipoInclusao}
        itemOrigem={itemOrigem}
        handleClose={this.refreshView}
      />
    );
  };

  render() {
    let {
      resources,
      intl,
      params,
      showModal,
      hiddenConsolidarOption,
      ignoreTag = false,
      filtroDefault,
      showColumns,
      refreshColumns,
    } = this.props;
    const { configuracao, configuracaoProcesso } = this.state;

    return (
      <div>
        {resources.area && configuracao && configuracaoProcesso && (
          <List
            url="/Processo"
            showCustomFields={!showModal}
            tipoItem={5}
            sort="UltimaVersao.Nome"
            editComponent={ProcessoEditView}
            searchComponent={
              <Search
                searchSchema={showModal ? SearchSchemaModal : SearchSchema}
                showModal={showModal}
              />
            }
            searchSchema={showModal ? SearchSchemaModal : SearchSchema}
            filterDrawer={!showModal}
            exibirPowerBI={true}
            pageSize={20}
            showPagination={true}
            hierarchy={true}
            handleNewClick={this.handleNewClick}
            valueField="nome"
            filtroId={showModal ? 308 : 307}
            showSearch={true}
            columns={showColumns}
            tag={ignoreTag ? null : showModal ? 2012 : 2013}
            showDelete={true}
            saved={this.state.saved}
            renderMenu={this.renderMenu}
            retirarTreeCamposCustomizados={true}
            selectedFilter={filtroDefault && { valor: filtroDefault }}
            modelValue={filtroDefault ? filtroDefault : null}
            searchModelFilter={filtroDefault ? filtroDefault : null}
            changedColumns={
              refreshColumns ? refreshColumns : this.state.changedColumns
            }
            customToolBar={
              !hiddenConsolidarOption &&
              this.toggleConsolidarSubItens(
                intl,
                resources,
                this.setConsolidaAreasSubordinadas
              )
            }
            parameters={{
              consolidaItensSubordinados:
                this.state.consolidarSubItens && !hiddenConsolidarOption,
              tag: ignoreTag ? null : showModal ? 2012 : 2013,
              ...params,
            }}
            {...this.props}
          >
            {this.getListColumn(
              this.props,
              configuracao,
              configuracaoProcesso,
              this.refreshView
            )}
          </List>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    user: state.user,
    moduloInteligenciaArtificial: state.user.moduloInteligenciaArtificial,
  };
}
export default injectIntl(connect(mapStateToProps)(Processo));
